<template>
  <article class="layout-grid -half -space-top">
    <div
      v-for="(image, index) in images"
      :key="image"
      v-appear="{ delay: 100 + index * 50, threshold: 0 }"
      class="layout-grid__item"
    >
      <figure class="layout-grid__figure" :style="{ '--image': `url('${image}')` }" />
    </div>
  </article>
</template>

<script>
export default {
  name: 'HomeEventsGallery',
  props: {
    images: {
      type: Array,
      default: Array
    }
  }
}
</script>
